import styled from "@emotion/styled";
import { transientOptions } from "@product/scmp-sdk";

import { AuthorAvatar } from "~/components/author/author-avatar";
import { StyledImage as AuthorAvatarImage } from "~/components/author/author-avatar/styles";

import { AuthorNames } from "./author-names";

type AuthorAvatarProps = {
  $zIndex: number;
};

export const StyledAuthorAvatar = styled(AuthorAvatar, { ...transientOptions })<AuthorAvatarProps>`
  position: relative;
  z-index: ${props => props.$zIndex};

  display: inline-block;

  inline-size: 60px;
  block-size: 60px;
  box-sizing: content-box;

  ${AuthorAvatarImage} {
    padding: 1px;
  }
`;

export const AvatarContainer = styled.div`
  ${StyledAuthorAvatar}:not(:first-child) {
    margin-inline-start: -16px;
  }
  ${StyledAuthorAvatar}:last-child {
    margin-inline-end: 16px;
  }
`;

type InformationContainerProps = {
  $authorsLength: number;
};
export const InformationContainer = styled.div<InformationContainerProps>`
  flex-grow: 1;

  padding-block-start: ${props => (props.$authorsLength > 1 ? "12px" : "0")};

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block-start: 0;
  }
`;

type ArticleAuthorBlockContainerProps = {
  $authorsLength: number;
};
export const ArticleAuthorBlockContainer = styled.div<ArticleAuthorBlockContainerProps>`
  display: flex;
  flex-flow: ${props => (props.$authorsLength > 1 ? "column" : "row")};
  justify-content: flex-start;
  align-items: stretch;

  ${props => props.theme.breakpoints.up("desktop")} {
    flex-flow: row;
  }
`;

export const ArticleDateAndLabelContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: stretch;

  ${props => props.theme.breakpoints.up("tablet")} {
    flex-flow: row;
  }
`;

export const StyledAuthorNames = styled(AuthorNames)`
  ${props => props.theme.breakpoints.up("tablet")} {
    max-inline-size: 500px;
    margin-block-end: 4px;
  }
`;
